"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { withSVGAttributes } from "../withSVGAttributes.js";
import { chevronVariants } from "./Chevron.variants.js";
const CHEVRON_LEFT_PATH = 'M12.7071 14.7079C12.3166 15.0985 11.6834 15.0985 11.2929 14.7079L7.05025 10.4653C6.65973 10.0748 6.65973 9.4416 7.05025 9.05108V9.05108C7.44078 8.66055 8.07394 8.66055 8.46447 9.05108L12.7071 13.2937C13.0976 13.6842 13.0976 14.3174 12.7071 14.7079V14.7079Z';
const CHEVRON_RIGHT_PATH = 'M11.293 14.7078C10.9025 14.3173 10.9025 13.6841 11.293 13.2936L15.5357 9.05099C15.9262 8.66046 16.5594 8.66046 16.9499 9.05099V9.05099C17.3404 9.44151 17.3404 10.0747 16.9499 10.4652L12.7073 14.7078C12.3167 15.0984 11.6836 15.0984 11.293 14.7078V14.7078Z';
const CHEVRON_FILL = 'var(--color-primary-8)';
const BaseChevronSVG = /*#__PURE__*/ forwardRef(({ isOpen = false, size = 24, ...props }, ref)=>{
    const { group, chevronLeft, chevronRight } = chevronVariants({
        ...props,
        isOpen
    });
    return /*#__PURE__*/ jsx("svg", {
        ref: ref,
        height: size,
        width: size,
        ...props,
        "data-testid": "chevron-svg",
        "data-state": isOpen ? 'open' : 'closed',
        children: /*#__PURE__*/ jsxs("g", {
            className: group(),
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: CHEVRON_LEFT_PATH,
                    fill: CHEVRON_FILL,
                    className: chevronLeft()
                }),
                /*#__PURE__*/ jsx("path", {
                    d: CHEVRON_RIGHT_PATH,
                    fill: CHEVRON_FILL,
                    className: chevronRight()
                })
            ]
        })
    });
});
BaseChevronSVG.displayName = 'BaseChevronSVG';
const Chevron = withSVGAttributes(BaseChevronSVG);
var Chevron_Chevron = Chevron;
export default Chevron_Chevron;
